<template>
  <div class="card card-fluid">
    <div class="card-header">Financiadoras agregadas</div>
    <div class="card-body">
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th style="min-width: 240px">Financiadora</th>
              <th>Presupuesto</th>
              <th>Convenio</th>
              <th style="width: 100px; min-width: 100px">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="funders.length">
              <tr
                v-for="(funder, key) in funders"
                :key="key"
                :funder="funder"
                is="funder-table-item"
                @remove-funder="removeFunder"
                @edit-funder="editFunder"
                @add-agreement="addAgreementFile"
                :readonly="readonly"
                :editable="editable"
              ></tr>
            </template>
            <template v-else>
              <tr>
                <td class="align-middle" colspan="4">
                  <p class="alert alert-success has-icon text-center d-flex align-items-center text-center"
                     role="alert"
                  >
                    <span class="w-100">No se han registrado financiadoras</span>
                  </p>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>

    <portal to="funders-modals">
      <file-modal
        title="Adjuntar convenio de financiadora"
        id="funder-agreement-modal"
        :save-files-function="attachAgreementFunction"
        ref="funder-agreement-modal"
      ></file-modal>

      <ok-cancel-dialog
        id="delete-funder-file-modal"
        title="Eliminar financiadora"
        content="<p>¿Está seguro de eliminar la financiadora?</p>"
        ok-button-text="Eliminar"
        ok-button-type="danger"
        @ok-button-pressed="deleteFunder"
        ref="delete-funder-file-modal"
      ></ok-cancel-dialog>

      <edit-funder-modal
        id="edit-funder-file-modal"
        title="Editar financiadora"
        :funder="funder"
        :amendment="amendment"
        v-if="funder"
        @funder-updated="funderInfoUpdated"
        ref="edit-funder-file-modal"
      ></edit-funder-modal>
    </portal>
  </div>
</template>
<script>
import FunderTableItem from "./FunderTableItem";
import FileModal from "../ui/FileModal";
import OkCancelDialog from "../ui/OkCancelDialog";
import EditFunderModal from "./EditFunderModal";

export default {
  name: "FundersTable",
  components: {
    FunderTableItem,
    FileModal,
    OkCancelDialog,
    EditFunderModal,
  },
  data() {
    return {
      funder: null,
    };
  },
  props: {
    funders: {
      type: Array,
      default: () => [],
    },
    protocol: {
      type: Object,
      default: null,
    },
    amendment: {
      type: Object,
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: true,
    },
    attachAgreementFunction: {
      type: Function,
      default: null,
    },
    deleteFunderFunction: {
      type: Function,
      default: null,
    },
  },
  methods: {
    /**
     *
     **/
    removeFunder(funder) {
      this.funder = funder;

      $("#delete-funder-file-modal").modal("show");
    },
    /**
     *
     **/
    editFunder(funder) {
      this.funder = funder;

      setTimeout(() => {
        $("#edit-funder-file-modal").modal("show");
      }, 500);
    },
    /**
     *
     * @param funder
     */
    addAgreementFile(funder) {
      this.funder = funder;

      this.$emit("add-agreement", funder);

      $("#funder-agreement-modal").modal("show");
    },
    /**
     *
     * @returns {Promise<void>}
     */
    async deleteFunder() {
      this.$refs["delete-funder-file-modal"].sending = true;

      if (this.deleteFunderFunction) {
        this.deleteFunderFunction(this.funder, () => {
          this.funder = null;

          this.$refs["delete-funder-file-modal"].sending = false;

          $("#delete-funder-file-modal").modal("hide");
        });
      }
    },

    /**
     *
     */
    funderInfoUpdated() {
      this.$emit('funder-updated')
    },
  },
  mounted() {},
};
</script>
